import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "./SoftwareProducts.css";
import Testimonial from "../../../Testimonial/Testimonial";

const SoftwareProducts = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  return (
    <div>
      <Helmet>
        <title>Software Products Development | Custom Software Solutions</title>
        <meta 
          name="description" 
          content="We develop innovative software products using cutting-edge technologies. Explore our comprehensive tech stack for building custom software solutions." 
        />
        <meta 
          name="keywords" 
          content="software products, custom software development, software solutions, enterprise software, SaaS products, web applications, mobile apps, software technology stack" 
        />
      </Helmet>
      
          <div className="mk-software-page">
      <div className="mk-hero-section-software">
        <div className="mk-hero-content">
          <h1 className="mk-hero-title mk-animate-fade-in">Innovative Software Solutions</h1>
          <p className="mk-hero-description mk-animate-slide-up">
            Empowering businesses with cutting-edge software products designed for efficiency, 
            scalability, and exceptional user experiences.
          </p>
          <a href="/contact-us"><button className="mk-cta-button mk-animate-pulse">Explore Our Solutions</button></a>
        </div>
        <div className="mk-hero-visual mk-animate-float">
          <div className="mk-visual-element mk-element-1"></div>
          <div className="mk-visual-element mk-element-2"></div>
          <div className="mk-visual-element mk-element-3"></div>
        </div>
      </div>

      <div className="mk-products-section">
        <h2 className="mk-section-title mk-animate-fade-in">Our Software Products</h2>
        <div className="mk-products-grid">
          <div className="mk-product-card mk-animate-card-rise">
            <div className="mk-product-icon">
              <i className="mk-icon-analytics"></i>
            </div>
            <h3 className="mk-product-title">Business Intelligence Suite</h3>
            <p className="mk-product-description">
              Advanced analytics platform that transforms your data into actionable insights 
              with intuitive dashboards and real-time reporting.
            </p>
            <ul className="mk-product-features">
              <li>Real-time data visualization</li>
              <li>Predictive analytics</li>
              <li>Custom reporting tools</li>
            </ul>
            <button className="mk-product-cta">Learn More</button>
          </div>

          <div className="mk-product-card mk-animate-card-rise">
            <div className="mk-product-icon">
              <i className="mk-icon-cloud"></i>
            </div>
            <h3 className="mk-product-title">Cloud Management Platform</h3>
            <p className="mk-product-description">
              Comprehensive cloud solution that simplifies deployment, management, 
              and scaling of your applications across multiple environments.
            </p>
            <ul className="mk-product-features">
              <li>Multi-cloud support</li>
              <li>Automated scaling</li>
              <li>Enhanced security protocols</li>
            </ul>
            <button className="mk-product-cta">Learn More</button>
          </div>

          <div className="mk-product-card mk-animate-card-rise">
            <div className="mk-product-icon">
              <i className="mk-icon-automation"></i>
            </div>
            <h3 className="mk-product-title">Workflow Automation</h3>
            <p className="mk-product-description">
              Streamline business processes with our intelligent automation tools 
              that reduce manual tasks and increase operational efficiency.
            </p>
            <ul className="mk-product-features">
              <li>Custom workflow design</li>
              <li>Integration capabilities</li>
              <li>Performance analytics</li>
            </ul>
            <button className="mk-product-cta">Learn More</button>
          </div>

          <div className="mk-product-card mk-animate-card-rise">
            <div className="mk-product-icon">
              <i className="mk-icon-security"></i>
            </div>
            <h3 className="mk-product-title">CyberShield Security</h3>
            <p className="mk-product-description">
              Enterprise-grade security software that protects your digital assets 
              with advanced threat detection and prevention mechanisms.
            </p>
            <ul className="mk-product-features">
              <li>Real-time threat monitoring</li>
              <li>Data encryption</li>
              <li>Compliance management</li>
            </ul>
            <button className="mk-product-cta">Learn More</button>
          </div>
        </div>
      </div>

      <div className="mk-features-section">
        <h2 className="mk-section-title mk-animate-fade-in">Why Choose Our Software</h2>
        <div className="mk-features-container">
          <div className="mk-feature-item mk-animate-feature-slide">
            <div className="mk-feature-number">01</div>
            <h3 className="mk-feature-title">Cutting-Edge Technology</h3>
            <p className="mk-feature-description">
              Our products are built with the latest technologies to ensure 
              optimal performance and future-proof solutions.
            </p>
          </div>

          <div className="mk-feature-item mk-animate-feature-slide">
            <div className="mk-feature-number">02</div>
            <h3 className="mk-feature-title">Seamless Integration</h3>
            <p className="mk-feature-description">
              Easily integrate with your existing systems through our 
              comprehensive API and support services.
            </p>
          </div>

          <div className="mk-feature-item mk-animate-feature-slide">
            <div className="mk-feature-number">03</div>
            <h3 className="mk-feature-title">24/7 Support</h3>
            <p className="mk-feature-description">
              Our dedicated team provides round-the-clock support to ensure 
              your operations run smoothly at all times.
            </p>
          </div>
        </div>
      </div>

      <div className="mk-cta-section">
        <div className="mk-cta-content">
          <h2 className="mk-cta-title">Ready to Transform Your Business?</h2>
          <p className="mk-cta-description">
            Schedule a free demo with our experts to discover how our software solutions 
            can address your specific business challenges.
          </p>
          <div className="mk-cta-buttons">
            <a href="https://wa.me/919155599968?text=Hello!%20I%E2%80%99m%20interested%20in%20exploring%20your%20software%20product%20features%20(dashboard%2C%20automation%2C%20reports).%20Can%20we%20schedule%20a%20demo%3F" 
   target="_blank" 
   rel="noreferrer"><button className="mk-cta-primary">Request a Demo</button></a>
            <a href="/contact-us"><button className="mk-cta-secondary">Contact Us</button></a>
          </div>
        </div>
      </div>
    </div>


      <Testimonial />

      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SoftwareProducts;